import React, { useMemo } from 'react';

import { Dropdown, Header, Icon, List, Message } from 'semantic-ui-react';

import { useSelector } from 'react-redux';

import { useQuestionGroups } from 'components/modules/questions/hooks/useQuestionGroups';
import { selectActiveProduct } from 'selectors';

export default function QuestionGroupSelector({ questionGroup, onQuestionGroupChange }) {
  const merchantProduct = useSelector(selectActiveProduct);
  const { loading, groups } = useQuestionGroups(merchantProduct);

  const options = useMemo(
    () =>
      groups.map((group) => ({
        key: group.id,
        text: group.name,
        value: group.id,
      })),
    [groups],
  );

  const questionsInGroup = useMemo(() => {
    return groups.find((group) => group.id === questionGroup)?.questions || [];
  }, [groups, questionGroup]);

  return (
    <>
      <label htmlFor="question-answer-block-name">Question Group</label>
      <Dropdown
        id="question-answer-block-name"
        fluid
        search
        selection
        options={options}
        value={questionGroup}
        placeholder="Select a question group"
        loading={loading}
        onChange={(e, { value: nextQuestionGroup }) => onQuestionGroupChange(nextQuestionGroup)}
      />
      <Header as="h4">Questions in group</Header>
      {questionsInGroup.length === 0 && (
        <Message warning>
          <Message.Header>
            <Icon name="warning sign" /> No questions in group
          </Message.Header>
          <p>
            This question group has no questions. Ensure you add questions to the group before using
            it in a page.
          </p>
        </Message>
      )}
      {questionsInGroup.length > 0 && (
        <List relaxed bulleted>
          {questionsInGroup.map((question) => (
            <List.Item key={question.id}>{question.text}</List.Item>
          ))}
        </List>
      )}
    </>
  );
}
